import { environment } from "src/environments/environment";

export const CONSTANTS = {
  APP: {
    BASE_APP_URL: environment.BASE_URL,
    API_KEY_HEADER: environment.API_KEY_HEADER,
    BASE_API_URL_METADATA: environment.BASE_API_URL_METADATA,
    BASE_API_URL_INVOICE: environment.BASE_API_URL_INVOICE,
    BASE_API_URL_ATUHENTICATION: environment.BASE_API_URL_AUTHENTICATION,
    BASE_API_URL_NOTIFICATION: environment.BASE_API_URL_NOTIFICATION,
    BASE_API_URL_PAYMENT: environment.BASE_API_URL_PAYMENT,
    BASE_API_URL_PRODUCT: environment.BASE_API_URL_PRODUCT,
    GMAIL_CLIENT_ID: environment.GMAIL_CLIENT_ID,
    BASE_API_URL_REPORT: environment.BASE_API_URL_REPORT,
    PUSHER_CLIENT_KEY: environment.PUSHER_CLIENT_KEY,
    PUSHER_CLIENT_CLUSTER: environment.PUSHER_CLIENT_CLUSTER,
  },
  API: {
    RESPONSE: {
      STATUS_CODE: {
        UNAUTHORIZED: 401,
        SUCCESS: 200,
        ERROR: 400,
      },
      STATUS_MESSAGE: {
        JWT_TOKEN_EXPIRED: "JWT Token expired.",
      },
    },
    ROUTE: {
      METADATA: {
        LOOKUP: "lookup",
        BANK: "bank",
        COUNTRY: "country",
        STATE: "state",
        CITY: "city",
      },
      CUSTOMER: {
        CUSTOMER: "customer",
        SEARCH: "search",
        STATUS: "status",
        COUNT: "count",
      },
      INVOICE: {
        INVOICE: "invoice",
        SAVE: "save",
        SEND_VIA_EMAIL: "share/email",
        SEND_VIA_SMS: "share/sms",
        SEND_VIA_WHATSAPP: "share/whatsapp",
        PREVIEW: "preview",
        STATUS: "status",
        EMAIL: "email",
        COUNT: "count",
        RECURRING_SETTING: "recurrence/setting",
        FULL_INVOICES: "share/full",
        LATE_FEE_SETTING: "invoice/late-charge",
        TEMPLATE: "template",
        EXPORT_PDF:"export/pdf",
      },
      AUTHENTICATION: {
        LOGIN: "login",
        LOGIN_CHALLENGE: "login/challenge",
        REFRESH_TOKEN: "token/refresh",
        LOGOUT: "logout",
        FORGOTPASSWORD: "password/forgot",
        VERIFYOTP: "otp/verify",
        RESETPASSWORD: "password/reset",
        SIGNUP: "signup",
        KYC: "kyc",
        SAVE: "save",
        KYC_DETAILS: "details", // local backend route is /kyc/details (was "view")
        VERIFY: "email/verify",
        RESEND_EMAIL: "signup/email/resend",
        KYC_STATUS: "kyc/status",
        KYC_DOC_REQUEST: "document/request",
      },
      PAYMENT: {
        GENERATE_KENT_LINK: "generate-link",
        OFFLINE_PAYMENT: "payment/offline",
        SETTLE_PAYMENT: "payment/settle",
        RECEIPT: "receipt",
      },
      PRODUCT: {
        PRODUCT: "product",
        LIST: "list",
        CATEGORY: "category",
        SUBCATEGORY: "sub-category",
        MANUFACTURER: "manufacturer",
        BRAND: "brand",
        VENDOR: "vendor",
        UNIT: "unit",
        METADATA: "metadata",
        STATUS: "status",
        PROVIDER: "provider",
        SEARCH: "search",
        PREFERENCE: "preference",
        VALIDATE: "validate",
        IMPORT: "import",
        VARIANT: "variant",
        TAG: "tag",
        EXISTS: "exists",
      },
      REPORT: {
        STATISTIC: "statistic",
        EXPORT: "export",
        CSV: "csv",
        EXCEL: "excel",
        PDF: "pdf",
        INVOICE: "invoice",
        CUSTOMERS: "customers",
        PAYMENT: "payment",
      },
      DASHBOARD: {
        DASHBOARD: "dashboard",
        CONTENT: "content",
        INVOICES: "invoices",
        CUSTOMERS: "customers",
        PRODUCTS: "products",
        TOP: "top",
        PAYMENTS: "payments",
        TRANSFER: "transfer",
      },
      SUPPORT: {
        LIST: "support/list",
        COUNT: "support/count",
        DETAIL: "support/",
        POST_RESPONSE: "support/response",
        STATUS_UPDATE: "support/query",
        POST_QUERY: "support/query",
      },
      NOTIFICATION: {
        GET_NOTIFICATION: "notifications",
      },
    },
  },
  LOOKUP_DATA: {
    INVOICE_STATUS: {
      DRAFT: 20,
      CREATED: 21,
      SENT: 22,
      PAID: 23,
      OVERDUE: 24,
      PARTIAL: 29,
      SCHEDULED: 116,
      TEMP:161,
      SETTLED : 162
    },
    INVOICE_STATUS_ID:{
      DELETED:3,
      ARCHIVE:2,
      ACTIVE:1
  },
    INVOICE_AMOUNT_RANGE: [
      { id: 1, value: "KWD 0  - KWD 100" },
      { id: 2, value: "KWD 101  - KWD 250" },
      { id: 3, value: "KWD 251  - KWD 500" },
      { id: 4, value: "KWD 501  - KWD 1000" },
      { id: 5, value: "KWD 1001  and above" },
    ],
    INVOICE_STATUS_LIST_DISPLAY: [
      {
        id: 23,
        status: "Paid",
      },
      {
        id: 22,
        status: "Sent",
      },
      {
        id: 29,
        status: "Partial",
      },
      {
        id: 24,
        status: "Overdue",
      },
      {
        id: 20,
        status: "Draft",
      },
      {
        id: 116,
        status: "Scheduled",
      },
      {
        id : 162,
        status:"Settled",
      }
    ],
    DISCOUNT_TYPE: [
      { id: 0, value: "%", description: "percentage" },
      { id: 1, value: "KWD", description: "flat" },
    ],
    CUSTOMER_STATUS_ID: {
      DELETED: 3,
      ARCHIVE: 2,
      ACTIVE: 1
    },
    BUSINESS_TYPE: {
      LICENSE: { id: 60, value: "Licensed Business" },
      HOME: { id: 61, value: "Home Business" },
    },
    ADDITIONAL_CHARGE_TYPE: [
      { id: 1, value: "KWD" },
      { id: 0, value: "%" },
    ],
    CURRENCY: {
      KD: "KWD",
    },
    CUSTOMER_TYPE: {
      BUSINESS: 3,
      INDIVIDUAL: 4,
    },
    CUSTOMER_TYPE_DISPLAY: [
      {
        id: 3,
        status: "Business",
      },
      {
        id: 4,
        status: "Individual",
      },
    ],
    INVOICE_TYPE: {
      QUICK: 5,
      DETAIL: 6,
    },
    CUSTOMER_PHONE_TYPE: {
      HOME: 9,
      MOBILE: 10,
      WORK: 11,
    },
    LATE_FEE_TYPE: {
      PERCENTAGE: 41,
      FLAT: 42,
    },
    WEIGHT_UNIT: [
      { id: 122, value: "kg" },
      { id: 123, value: "g" },
      { id: 132, value: "mg" },
      { id: 124, value: "ug" },
      { id: 125, value: "µg" },
      { id: 126, value: "Gt" },
    ],
    DIMENSIONS_UNIT: [
      { id: 120, value: "cm" },
      { id: 128, value: "mm" },
      { id: 121, value: "m" },
      { id: 129, value: "dc" },
      { id: 130, value: "km" },
      { id: 131, value: "in" },
    ],
    PRODUCT_TYPE: {
      GOODS: 110,
      SERVICE: 111,
    },
    PRODUCT_STATUS: {
      ACTIVE: 91,
      DRAFT: 92,
      INACTIVE: 136,
      DELETED: 137,
    },
    PRODUCT_STATUS_REPORT_DISPLAY: [
      {
        id: 91,
        status: "Active",
      },
      {
        id: 92,
        status: "Draft",
      },
      {
        id: 136,
        status: "Inactive",
      },
    ],
    PRODUCT_TYPE_REPORT_DISPLAY: [
      {
        id: 110,
        status: "Goods",
      },
      {
        id: 111,
        status: "Service",
      },
    ],
    PRODUCT_INVENTORY_STATUS_DISPLAY: [
      {
        id: 1,
        status: "In Stock",
      },
      {
        id: 0,
        status: "Out of Stock",
      },
    ],
    PRODUCT_VARIENT_STATUS_LISTING_FOR_FILTER_STATUS: [
      {
        id: null,
        status: "All",
      },
      {
        id: 91,
        status: "Active",
      },
      {
        id: 92,
        status: "Draft",
      },
    ],
    PAR_PAGE_RECORD_DATA: [
      { id: 1, value: "10" },
      { id: 2, value: "20" },
      { id: 3, value: "30" },
      { id: 4, value: "40" },
      { id: 5, value: "50" },
      { id: 6, value: "60" },
      { id: 7, value: "70" },
      { id: 8, value: "80" },
      { id: 9, value: "90" },
      { id: 10, value: "100" },
    ],
    PRODUCT_STATUS_FOR_INACTIVE_AND_DELETE: {
      INACTIVE: 0,
      ACTIVE: 1,
      DELETE: 3,
    },
    RECORD_TYPE: {
      SINGLE: "single",
      MULTI: "multi",
    },
    DOWNLOAD_SAMPLE_FILE_FOR_GOODS:
      "https://payfils-merchant-static-contents-dev.s3.eu-central-1.amazonaws.com/goods_sample_product_import.xlsx",
    DOWNLOAD_SAMPLE_FILE_FOR_SERVICE:
      "https://payfils-merchant-static-contents-dev.s3.eu-central-1.amazonaws.com/service_sample_product_import.xlsx",
    PRODUCT_TYPE_FOR_VIEW_DELETED_PRODUCT: {
      GOODS: "goods",
      SERVICE: "service",
    },

    PAYMENT_TYPE_DISPLAY: [
      {
        id: 58,
        status: "KNET",
      },
      {
        id: 47,
        status: "Offline",
      },
    ],

    TRANSACTION_STATUS_LIST: [
      {
        id: 133,
        status: "Success",
      },
      {
        id: 135,
        status: "Failed",
      },
    ],

    TRANSFER_STATUS_LIST: [
      {
        id: 134,
        status: "Success ",
      },
      {
        id: 138,
        status: "Failed",
      },
      // {
      //     id: 139,
      //     status: 'Processing'
      // }
    ],
    KYC_STATUS_IDS: {
      RECEIVED: 142,
      VERIFIED: 143,
      REJECTED: 144,
      RESUBMITTED: 145,
      REQUEST_TO_RESUBMIT: 146,
    },
    DESIGNATION_IDS: {
      OTHERS: 105
    },
    SUPPORT_TICKET_STATUS: [
      {
        id: 148,
        status: "Open",
      },
      {
        id: 152,
        status: "Resolved",
      },
      {
        id: 153,
        status: "Reopened",
      },
      {
        id: 155,
        status: "Closed",
      },
    ],
    SUPPORT_TICKET_PRIORITY: [
      {
        id: 1,
        status: "High",
      },
      {
        id: 2,
        status: "Medium",
      },
      {
        id: 3,
        status: "Low",
      },
    ],
    INVOICE_TEMPLATE: [
      { id: 156, template: 0 },
      { id: 157, template: 1 },
      { id: 158, template: 2 },
      { id: 159, template: 3 },
      { id: 160, template: 4 },
    ],
  },

  ALLOWEDTYPES: ["application/pdf", "image/jpeg", "image/jpg", "image/png"],
  DATE_START_TIME: " 00:00:00",
  DATE_END_TIME: " 23:59:59",
};
